(() => {
  if (customElements.get('eooqi-sticky-purchase')) return;
  customElements.define('eooqi-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.root = document.querySelector('main eooqi-market-product,main eooqi-pet-product,main eooqi-catalog-product');
      this.purchase = this.root?.querySelector('.eap-purchase');
      if (!this.purchase) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {this.frame=0;this.update();});
      };
      for (const name of ['eooqi:variant-change','eooqi:market-change','focusin','focusout','visitorConsentCollected']) document.addEventListener(name,this.schedule,options);
      for (const name of ['toggle','close']) document.addEventListener(name,this.schedule,{...options,capture:true});
      window.addEventListener('scroll',this.schedule,{...options,passive:true});
      for (const name of ['resize','popstate','pageshow']) window.addEventListener(name,this.schedule,options);
      window.visualViewport?.addEventListener('resize',this.schedule,options);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.purchase,{subtree:true,attributes:true,childList:true,attributeFilter:['hidden','href','aria-disabled','aria-busy','data-amazon-market']});
      this.overlays = new MutationObserver(this.schedule);
      this.overlays.observe(document.body,{subtree:true,attributes:true,childList:true,attributeFilter:['open','aria-modal','aria-hidden']});
      this.update();
    }
    update() {
      const visible = node => Boolean(node && !node.closest('[hidden],[aria-hidden="true"],details:not([open])') && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden' && getComputedStyle(node).display !== 'none');
      const selected = this.root.dataset.selected;
      const panel = [...this.purchase.querySelectorAll('[data-variant-panel]')].find(node => node.dataset.variantPanel === selected && visible(node));
      const source = [...(panel?.querySelectorAll('a[data-eooqi-amazon]') || [])].find(node => visible(node) && node.hasAttribute('href') && node.getAttribute('aria-disabled') !== 'true' && !node.closest('[aria-busy="true"]'));
      const modal = [...document.querySelectorAll('dialog[open],[aria-modal="true"],header details[open],#shopify-pc__banner')].some(visible);
      const typing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
      const rect = source?.getBoundingClientRect();
      const height = window.visualViewport?.height || innerHeight;
      const mainVisible = visible(source) && rect.bottom > 0 && rect.top < height && rect.right > 0 && rect.left < innerWidth;
      if (!source || mainVisible || modal || typing) {this.hidden=true;return;}
      const label = panel.querySelector('.eap-selected')?.textContent.trim() || this.root.querySelector('[data-selected-variant-title],h1')?.textContent.trim() || '';
      const signature = [selected,source.getAttribute('href'),source.textContent,label,source.dataset.amazonMarket].join('|');
      if (this.signature !== signature) {
        const link = source.cloneNode(true);
        link.removeAttribute('id');
        link.className = 'esp-button';
        link.dataset.eooqiPlacement = 'product_sticky';
        this.querySelector('[data-sticky-action]').replaceChildren(link);
        this.querySelector('[data-sticky-selection]').textContent = label;
        this.signature = signature;
      }
      this.hidden=false;
    }
    disconnectedCallback() {
      this.abort?.abort();this.abort=null;
      this.observer?.disconnect();this.overlays?.disconnect();
      cancelAnimationFrame(this.frame);this.frame=0;
    }
  });
})();
